module.exports = __webpack_public_path__ + "static/mini_calendar_customize_template-aa860d035b98d9df4405012dcdf92020.png";